export const PHONE_DISPLAY = "99734 16270";
export const PHONE_TEL = "tel:+919973416270";
export const LOCATION = "Anishabad, Patna";
export const INSTAGRAM = "Speech Horizon";

export const waLink = (message) =>
    `https://wa.me/919973416270?text=${encodeURIComponent(message)}`;

export const WA_DEFAULT = waLink(
    "Namaste Speech Horizon! I would like to book a consultation for speech & language therapy. Please share the available time slots."
);

export const NAV_LINKS = [
    { label: "Home", path: "/" },
    { label: "About", path: "/about" },
    { label: "Services", path: "/services" },
    { label: "Autism Therapy", path: "/autism-therapy" },
    { label: "Speech Delay", path: "/speech-delay" },
    { label: "Parent Guidance", path: "/parent-guidance" },
    { label: "Contact", path: "/contact" },
];

export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1607453998774-d533f65dac99?w=1200&q=80&auto=format&fit=crop",
    about: "https://images.unsplash.com/photo-1519340241574-2cec6aef0c01?w=900&q=80&auto=format&fit=crop",
    aman: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&q=80&auto=format&fit=crop",
    reading: "https://images.unsplash.com/photo-1471286174890-9c112ffca5b4?w=1000&q=80&auto=format&fit=crop",
    learning: "https://images.unsplash.com/photo-1544776193-352d25ca82cd?w=1000&q=80&auto=format&fit=crop",
    family: "https://images.unsplash.com/photo-1609220136736-443140cffec6?w=1000&q=80&auto=format&fit=crop",
    play: "https://images.unsplash.com/photo-1472162072942-cd5147eb3902?w=1000&q=80&auto=format&fit=crop",
    kids: "https://images.unsplash.com/photo-1516627145497-ae6968895b74?w=1000&q=80&auto=format&fit=crop",
    classroom: "https://images.unsplash.com/photo-1509062522246-3755977927d7?w=1000&q=80&auto=format&fit=crop",
};

export const SERVICES = [
    {
        icon: "MessagesSquare",
        title: "Speech Delay",
        description:
            "If a child is not developing words or sentences according to their age, an appropriate assessment and individualized speech-language therapy can help support the development of communication skills.",
        link: "/speech-delay",
        tint: "teal",
    },
    {
        icon: "BookOpen",
        title: "Language Development",
        description:
            "We focus on developing vocabulary, language comprehension, sentence formation, and functional communication skills to support effective everyday communication.",
        link: "/services",
        tint: "sky",
    },
    {
        icon: "Mic",
        title: "Articulation & Pronunciation",
        description:
            "For individuals experiencing difficulty producing speech sounds or pronouncing words clearly, we use structured and systematic practice to improve speech sound production and overall clarity.",
        link: "/services",
        tint: "peach",
    },
    {
        icon: "AudioWaveform",
        title: "Stammering / Fluency",
        description:
            "Individualized strategies and therapy techniques are used to support speech fluency, improve communication confidence, and help individuals communicate more comfortably.",
        link: "/services",
        tint: "teal",
    },
    {
        icon: "Volume2",
        title: "Voice Therapy",
        description:
            "We provide appropriate therapeutic support for difficulties related to voice quality, pitch, loudness, and healthy voice use.",
        link: "/services",
        tint: "sky",
    },
    {
        icon: "Sparkles",
        title: "Autism & Communication",
        description:
            "For autistic children, therapy may focus on functional communication, social communication, vocabulary development, sentence formation, requesting, and interaction skills.",
        link: "/autism-therapy",
        tint: "peach",
    },
];

export const PEDIATRIC_AREAS = [
    "Autism Spectrum Disorder",
    "Speech Delay",
    "Language Delay",
    "Developmental Delay",
    "ADHD",
    "Intellectual Disability",
    "Down Syndrome",
    "Social Communication Difficulties",
    "Limited Vocabulary",
    "Difficulty with Sentence Formation",
    "Difficulty Following Instructions",
    "Communication Difficulties",
];

export const WORK_AREAS = [
    {
        icon: "Eye",
        title: "Social Communication",
        description:
            "Developing skills such as eye contact, turn-taking, joint attention, and meaningful social interaction.",
    },
    {
        icon: "MessageCircle",
        title: "Functional Communication",
        description:
            "Helping children communicate their needs, wants, choices, and feelings in meaningful and functional ways.",
    },
    {
        icon: "BookOpen",
        title: "Language Skills",
        description:
            "Supporting vocabulary development, understanding of concepts, sentence formation, and language comprehension.",
    },
    {
        icon: "Mic",
        title: "Speech Sounds",
        description:
            "Using structured practice to improve difficult speech sounds, pronunciation, and overall speech clarity.",
    },
    {
        icon: "Ear",
        title: "Attention & Listening",
        description:
            "Developing listening skills, the ability to follow instructions, sustain attention, and participate effectively in activities.",
    },
    {
        icon: "Users",
        title: "Social Skills",
        description:
            "Building skills such as greeting others, asking and answering questions, engaging in conversations, and participating in appropriate social interactions.",
    },
];

export const PRINCIPLES = [
    "Individualized",
    "Child-Friendly",
    "Goal-Oriented",
    "Structured",
    "Practical",
    "Progress-Based",
];

export const WHY_CHOOSE = [
    {
        icon: "User",
        title: "Personalized Therapy",
        description:
            "Therapy is planned according to each individual's specific needs, abilities, and goals.",
    },
    {
        icon: "Focus",
        title: "Individual Attention",
        description:
            "Focused attention is given to the individual's specific communication difficulties throughout the therapy process.",
    },
    {
        icon: "Smile",
        title: "Child-Friendly Environment",
        description:
            "Children are encouraged to participate through comfortable, engaging, and age-appropriate activities.",
    },
    {
        icon: "Target",
        title: "Goal-Oriented Sessions",
        description:
            "Each therapy session is planned around clear, practical, and meaningful goals.",
    },
    {
        icon: "Heart",
        title: "Parent Guidance",
        description:
            "Parents receive simple and practical suggestions to support communication and home practice.",
    },
    {
        icon: "TrendingUp",
        title: "Progress Monitoring",
        description:
            "Progress is regularly observed and reviewed based on therapy goals, allowing the therapy plan to be updated when needed.",
    },
];

export const THERAPY_STEPS = [
    {
        icon: "Search",
        title: "Assessment",
        description:
            "We begin by understanding the individual's speech, language, communication, and related skills.",
    },
    {
        icon: "Target",
        title: "Goal Setting",
        description:
            "Individualized therapy goals are established based on the individual's needs, strengths, and areas of difficulty.",
    },
    {
        icon: "Sparkles",
        title: "Personalized Therapy",
        description:
            "Structured activities and appropriate therapy techniques are used to work toward the identified goals.",
    },
    {
        icon: "Home",
        title: "Home Practice",
        description:
            "Parents are provided with suitable activities and practical strategies to continue supporting communication development at home.",
    },
    {
        icon: "TrendingUp",
        title: "Progress Review",
        description:
            "Progress is regularly reviewed, and therapy goals are updated as needed to ensure continued development.",
    },
];

export const BENEFIT_SIGNS = [
    "Is not developing speech according to their age",
    "Uses very few words",
    "Has difficulty forming sentences",
    "Is difficult to understand when speaking",
    "Has difficulty following instructions",
    "Relies heavily on gestures or behaviours to communicate",
    "Has difficulty with social interaction",
    "Experiences communication difficulties associated with autism",
    "Experiences stammering or difficulties with speech fluency",
    "Has difficulties related to their voice",
];
